import { applyGroupAnswerAndVisibility } from "../reducer/actions/updateAnswerAction";
import { mergeAnswers } from "./mergeAnswers";
import type { Answers, Groups, UpdateAnswerPayload } from "../types";

type ComputeMergedAnswersWithGroupsArgs = {
  answers: Answers;
  groups: Groups;
  payload: UpdateAnswerPayload;
};

/**
 * Computes the merged answers after applying an update payload.
 * Handles shadow groups by transforming array selections into individual yes/no answers.
 *
 * This utility delegates to applyGroupAnswerAndVisibility to avoid code duplication,
 * providing a minimal state structure and discarding the visibility updates.
 */
export const computeMergedAnswersWithGroups = ({
  answers,
  groups,
  payload,
}: ComputeMergedAnswersWithGroupsArgs): Answers => {
  const mergedAnswers = mergeAnswers(answers, payload);

  const { answers: groupAnswers } = applyGroupAnswerAndVisibility(
    {
      groups,
      answers: mergedAnswers,
      visibility: {},
      asyncErrors: {},
      sections: [{ id: "", questions: [] }],
      currentSectionIndex: 0,
      lastViewedSectionIndex: 0,
    },
    payload,
    {},
  );

  return groupAnswers;
};
